import { render, staticRenderFns } from "./EmailBodyHeader.vue?vue&type=template&id=34f8114a"
import script from "./EmailBodyHeader.vue?vue&type=script&lang=js"
export * from "./EmailBodyHeader.vue?vue&type=script&lang=js"
import style0 from "./EmailBodyHeader.vue?vue&type=style&index=0&id=34f8114a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports